import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import IsInStock from "./IsInStock";
import { getTurkishPlural } from "../../utils/getTurkishPlural";
import ErcModal from "../../modules/shared/components/ErcModal";
import PriceOfferChildExplainer from "./PriceOfferChildExplainer";
import { calculateDisplayedPrice } from "../../utils/calculateDisplayedPrice";
import CountDownTimerVisibilityAware from "../CountDownTimer/CountDownTimerVisibilityAware";
import { useCalculateDiscountEndTime } from "../../hooks/useCalculateDiscountEndTime";

export default function PriceOfferChildTimeRestrictedDiscounted(props) {
  const location = useLocation();

  // PROPS COMING FROM PriceOffer
  const { product, price, validPrice, remainingTime, cartSkuItems } = props;

  // DISCOUNT ENDS TIME
  const displayDate = useCalculateDiscountEndTime(remainingTime);

  // STATES TO HOLD DISCOUNT INFO
  const [firstDiscount, setFirstDiscount] = useState(0);
  const [additionalDiscount, setAdditionalDiscount] = useState(0);
  useEffect(() => {
    if (price && validPrice) {
      setFirstDiscount(price.price - validPrice);
      setAdditionalDiscount(price.price - price.priceGap);
    }
  }, [price, validPrice]);

  return (
    <div className="table-wrapper">
      <div className="table-border-text grey helvetica">Süreli İndirim</div>
      <table>
        <thead>
          <tr>
            <th colSpan={2}>
              <CountDownTimerVisibilityAware milliseconds={remainingTime} />
            </th>
          </tr>
        </thead>
        <tbody>
          {cartSkuItems.length === 0 || location.pathname.includes("/land/") ? (
            <tr>
              <th
                style={{
                  width: "45%",
                }}
              >
                <div className="row w70p txtleft">
                  İlk {product.productUnit}{" "}
                  <ErcModal
                    modalTitle={() => (
                      <i className="far fa-question-circle green fs1 marq"></i>
                    )}
                    modalTitleFontSize={"1.25rem"}
                    modalTitleLineHeight={"2rem"}
                    modalTitleColor={"#0645ad"}
                    modalTitleUnderline={""}
                    contentTitle={`İlk Adet Fiyatı Ne Demek?`}
                    contentTitleFontSize={"1.35rem"}
                    content={[
                      <PriceOfferChildExplainer
                        price={price.price}
                        firstDiscount={firstDiscount}
                        remainingTime={remainingTime}
                        additionalDiscount={additionalDiscount}
                        product={product}
                        context={"firstUnit"}
                      />,
                    ]}
                    modalParagBorderBottom={""}
                    modalParagFontSize={"1.25rem"}
                  />
                </div>
              </th>
              <td>
                <div className="row fs125 txtcenter padq">
                  <strike className="red-col bold-font">
                    {calculateDisplayedPrice(price.price)}
                  </strike>{" "}
                  <p>
                    {calculateDisplayedPrice(validPrice)}{" "}
                    <span className="fs-85">TL</span>
                  </p>
                </div>
              </td>
            </tr>
          ) : (
            <tr></tr>
          )}
          <tr>
            <th
              style={{
                width: "48%",
              }}
            >
              <div className="row w80p txtleft">
                Ek {getTurkishPlural(product.productUnit)}
                <ErcModal
                  modalTitle={() => (
                    <i className="far fa-question-circle green fs1 marq"></i>
                  )}
                  modalTitleFontSize={"1.25rem"}
                  modalTitleLineHeight={"2rem"}
                  modalTitleColor={"#0645ad"}
                  modalTitleUnderline={""}
                  contentTitle={`Ek Adetler Fiyatı Ne Demek?`}
                  contentTitleFontSize={"1.35rem"}
                  content={[
                    <PriceOfferChildExplainer
                      price={price.price}
                      firstDiscount={firstDiscount}
                      remainingTime={remainingTime}
                      additionalDiscount={additionalDiscount}
                      product={product}
                      context={"additionalUnits"}
                    />,
                  ]}
                  modalParagBorderBottom={""}
                  modalParagFontSize={"1.25rem"}
                />
              </div>
            </th>
            <td>
              <div className="row fs125 txtcenter padq">
                <strike className="red-col bold-font">
                  {calculateDisplayedPrice(price.price)}
                </strike>{" "}
                <p>
                  {calculateDisplayedPrice(price.priceGap)}{" "}
                  <span className="fs-85">TL</span>
                </p>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th colSpan={2}>
              <IsInStock product={product} />
              <p className="padq lh1-25 lightredbck">
                <span className="alert-border-bottom">{displayDate}</span>{" "}
                olduğunda üstü çizili olan{" "}
                <span className="red-col bold-font">
                  {calculateDisplayedPrice(price.price)} TL
                </span>{" "}
                geçerli olacaktır.
              </p>
              <p className="padh slightlyyellowbck green">
                Süre dolmadan siparişinizi oluşturun, tasarruf edin
              </p>
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
